import styled from 'styled-components';
import colors from 'styles/colors';

import { Modal as SemanticModal } from 'semantic-ui-react';
import { BackButton, CancelButton } from 'components/Buttons';
import { StyledSearchableCard } from './components/styles';
import { SectionContent } from 'styles/cards';

export const StyledModal = styled(SemanticModal)`
  width: 864px !important;
  border-radius: 4px !important;
`;

export const StyledModalHeader = styled(SemanticModal.Header)`
  display: flex !important;
  align-items: center;
  height: 70px;
  padding: 0 30px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  border-bottom: 1px solid ${colors.black} !important;
`;

export const StyledModalContent = styled(SemanticModal.Content)`
  padding: 24px 30px !important;
`;

export const StyledDescription = styled.p`
  padding: 2px 0 21px 0;
`;

export const StyledModalActions = styled(SemanticModal.Actions)`
  display: flex;
  align-items: center;
  height: 79px;
  padding: 24px 32px !important;
  background-color: ${colors.white} !important;
  border-top: 1px solid ${colors.fleetOffGray} !important;
`;

export const StyledCancelButton = styled(CancelButton)`
  margin-right: auto;

  div {
    justify-content: center;
  }
`;

export const StyledBackButton = styled(BackButton)`
  margin-right: auto;

  div {
    justify-content: center;
  }
`;

export const Modal = styled.div`
  min-width: 600px;
  border: 1px solid ${colors.fleetOffGray};
  border-radius: 4px;
  box-shadow: 0px 2px 6px 0px ${colors.shadowBorder};
  background-color: ${colors.white};
`;

export const ModalHeaderActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const CustomerSearchableCard = styled(StyledSearchableCard)`
  width: 700px;
`;

export const StyledSectionContent = styled(SectionContent)`
  flex-direction: row;
  gap: 16px;

  & > * {
    flex-basis: 50%;
  }
`;
